import { render, staticRenderFns } from "./appdownload.vue?vue&type=template&id=093aa602"
import script from "./appdownload.vue?vue&type=script&lang=js"
export * from "./appdownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports